module.exports = __webpack_public_path__ + "media/images/editorial_board_icons/eb_nosek_sm-3c04a44306bff669a30d6499f764c40e.png";